module.exports = __webpack_public_path__ + "img/indent.be731253.svg";